export default __webpack_public_path__ + "static/patience-854515c148ec579403a4ad4a7f51707a.png";